//@flow
import React from 'react';
import BaseModal from '../../Modal/components/BaseModal.react';
import CreateAccountModalActions from '../../Actions/createAccountModal';
import CreateAccountModalStore from '../../Stores/CreateAccountModal/createAccountModal';
import LoginForm from '../../SignIn/components/LoginFormWrapper.react';

type Props = {
  isOpen:boolean,
};

function _closeModal() {
  CreateAccountModalActions.closeCreateAccountModal();
}

function _getClassName() {
  const expanded = CreateAccountModalStore.isExpanded();
  return expanded ? "-expanded" : "";
}

export default function CreateAccountModal(props:Props) {
  return (
    <BaseModal
      className={"login-modal " + _getClassName()}
      isOpen={props.isOpen}
      closeModal={_closeModal}
    >
      <LoginForm
        initialNewUser={true}
        modal={true}
      />
    </BaseModal>
  );
}
